import { useState, useEffect } from "react";
import API from "../../../services/API/CRM";
import MultiSelect from "../../Inputs/MultiSelect";


export default function EventsSelect({value, onChange}){

    const [types, setTypes] = useState([])

    useEffect(() => {

        API.getActivityEvents()
            .then(r => setTypes(r.data))

    }, [])


    return <MultiSelect 
        label='Évènements'
        options={types.sort((a,b) => a.title > b.title ? 1 : -1)}
        value={types.length > 0 ? value : []}
        onChange={onChange}
    />
}